import type { AppStatus } from "../types";

export interface RecoveryAction {
  label: string;
  visible: boolean;
}

export function getRecoveryAction(status: AppStatus): RecoveryAction {
  if (
    status === "permission-denied" ||
    status === "technical-error" ||
    status === "target-missing" ||
    status === "incompatible"
  ) {
    return {
      label: "Tentar novamente",
      visible: true,
    };
  }

  return {
    label: "Tentar novamente",
    visible: false,
  };
}
